import { listModelManager } from '@/utils/http'
import { unwrapRows, resolveImageUrl } from '@/utils/content'
import { setBrandingCache, refreshPageTitle } from '@/utils/pageTitle'
export const BRANDING_TYPE_FAVICON = 8
export const BRANDING_TYPE_TITLE_ZH = 9
export const BRANDING_TYPE_TITLE_EN = 10

let brandingCache = null
let brandingLoading = null

export function resetSiteBrandingCache() {
  brandingCache = null
  brandingLoading = null
}

export function mapSiteBranding(rows) {
  let favicon = ''
  let titleZh = ''
  let titleEn = ''
  ;(rows || [])
    .filter(r => Number(r.status) === 1)
    .forEach(row => {
      const type = Number(row.type)
      if (type === BRANDING_TYPE_FAVICON && row.nbpicUrl) {
        favicon = resolveImageUrl(row.nbpicUrl)
      } else if (type === BRANDING_TYPE_TITLE_ZH && row.modelPicurl) {
        titleZh = String(row.modelPicurl).trim()
      } else if (type === BRANDING_TYPE_TITLE_EN && row.modelPicurl) {
        titleEn = String(row.modelPicurl).trim()
      }
    })
  return { favicon, titleZh, titleEn }
}

export function applyFavicon(url) {
  if (!url || typeof document === 'undefined') return
  document
    .querySelectorAll('link[rel*="icon"], link[rel="apple-touch-icon"], link[rel="shortcut icon"]')
    .forEach(el => el.remove())

  ;['16x16', '32x32', '48x48', '64x64', '96x96', '128x128', '192x192'].forEach(size => {
    const link = document.createElement('link')
    link.rel = 'icon'
    link.type = 'image/png'
    link.sizes = size
    link.href = url
    document.head.appendChild(link)
  })

  const shortcut = document.createElement('link')
  shortcut.rel = 'shortcut icon'
  shortcut.href = url
  document.head.appendChild(shortcut)

  const apple = document.createElement('link')
  apple.rel = 'apple-touch-icon'
  apple.sizes = '180x180'
  apple.href = url
  document.head.appendChild(apple)
}

export function applySiteBranding(branding, locale) {
  if (!branding) return
  setBrandingCache(branding)
  if (branding.favicon) applyFavicon(branding.favicon)
  refreshPageTitle(locale)
}

export async function fetchSiteBranding(force = false) {
  if (!force && brandingCache) return brandingCache
  if (!force && brandingLoading) return brandingLoading

  brandingLoading = (async () => {
    try {
      const res = await listModelManager({ status: 1, pageNum: 1, pageSize: 50 })
      brandingCache = mapSiteBranding(unwrapRows(res))
      setBrandingCache(brandingCache)
      return brandingCache
    } catch (e) {
      brandingCache = { favicon: '', titleZh: '', titleEn: '' }
      setBrandingCache(brandingCache)
      return brandingCache
    } finally {
      brandingLoading = null
    }
  })()

  return brandingLoading
}

export async function initSiteBranding(locale) {
  const branding = await fetchSiteBranding()
  applySiteBranding(branding, locale)
  return branding
}
